<!--
    Header override — overrulet alleen de logout() methode van de Wielink header.

    Reden: de Wielink-versie gebruikt $.ajax voor de logout. AJAX volgt
    server-side redirects niet in browser-navigatie, waardoor de 302 naar
    Microsoft's logout endpoint niet gevolgd wordt en de MS-sessie open blijft.
    Een form-submit navigeert de browser wél mee met redirects.

    CSRF-token komt uit $page.props.csrf_token (onversleutelde token,
    bij elke Inertia response vers gegenereerd). De XSRF-TOKEN cookie is
    encrypted en dus niet bruikbaar voor form-body tokens.
-->
<script>
import Header from '@wielink-application/shared/vue/layouts/partials/header.vue'

export default {
	extends: Header,
	methods: {
		logout() {
			const form = document.createElement('form');
			form.method = 'POST';
			form.action = this.route('logout');

			const tokenInput = document.createElement('input');
			tokenInput.type = 'hidden';
			tokenInput.name = '_token';
			tokenInput.value = this.$page.props.csrf_token;
			form.appendChild(tokenInput);

			document.body.appendChild(form);
			form.submit();
		},
	},
};
</script>